import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getLiquidityPool } from "../../utils/contractHelpers";
import { LUCKIFY_CONTRACT_ADDRESS } from "../../utils/Enviroment";


export const ClaimReward = () => {
    const web3 = useWeb3();
    const stakingAddress = LUCKIFY_CONTRACT_ADDRESS;
    const contract = getLiquidityPool(stakingAddress, web3);
    const { account } = useWeb3React()
    const ClaimRewardHook = useCallback(
        async () => {
            let gasPrice = await web3.eth.getGasPrice();
            // gasPrice = parseInt(gasPrice) + 1000000000;
            try {
                const gas = await contract?.methods?.claimRewards()?.estimateGas({ from: account })
                const claimRewards = await contract?.methods?.claimRewards()?.send({ from: account, gas: gas, gasPrice: gasPrice })
                return claimRewards;
            } catch (e) {
                throw e;
            }
        },
        [contract, web3, account]
    );
    return { ClaimRewardHook: ClaimRewardHook };
};

export default ClaimReward;










